<template>
<div class="task-inline-date">
 <label class="small">Срок пункта</label>
 <b-form-select :value="selected" :options="options" :disabled="busy" @change="select" aria-label="Общая контрольная дата" />
 <template v-if="selected !== '' && canEdit">
  <b-form-input v-model="label" maxlength="255" :disabled="busy" placeholder="Название контроля · необязательно" aria-label="Название контроля" />
  <b-form-input v-model="due" type="datetime-local" :max="deadline || null" :disabled="busy" aria-label="Дата и время контроля" />
  <TaskRelativeTime :value="due" full />
 </template>
 <p v-if="shared" class="small mt-2">Эта дата связана с {{ original.linked_items_count }} пунктами. Перенести её для всех или создать отдельную?</p>
 <div class="tasks-actions mt-2">
  <b-button size="sm" :disabled="busy" @click="$emit('cancel')">Отмена</b-button>
  <b-button v-if="shared" size="sm" variant="outline-primary" :disabled="busy" @click="save(true)">Создать отдельную для этого пункта</b-button>
  <b-button size="sm" variant="primary" :disabled="busy" @click="save(false)">{{ shared ? 'Перенести для всех' : 'Сохранить срок' }}</b-button>
 </div>
 <b-button v-if="original" size="sm" variant="link" :disabled="busy" @click="refreshVersion">Обновить версию, сохранив ввод</b-button>
 <div v-if="error" role="alert" class="text-danger small mt-2">{{ error }}</div>
</div>
</template>
<script>
import TaskRelativeTime from './TaskRelativeTime';
import {taskDraftId} from './taskPresentation';
export default {
 components: {TaskRelativeTime},
 props: {draft: Object, points: Array, value: String, canEdit: Boolean, busy: Boolean, deadline: String},
 data: () => ({selected: '', original: null, label: '', due: '', error: '', draftId: taskDraftId()}),
 computed: {
  options() { return [{value:'',text:'Без срока'}].concat(this.canEdit ? [{value:'new',text:'Новая контрольная дата'}] : [], (this.points || []).map(p => ({value:p.id,text:(p.label || 'Контроль') + ' · ' + this.$moment(p.due_at).format('DD.MM.YYYY HH:mm')}))); },
  changed() { return this.canEdit && (this.selected === 'new' || this.original && (this.label !== this.original.label || this.$moment(this.due).valueOf() !== this.$moment(this.original.due_at).valueOf())); },
  shared() { return this.changed && this.original && this.original.linked_items_count > 1; }
 },
 created() { this.select(this.value || (this.canEdit ? 'new' : '')); if (this.draft && this.draft.controlPoint) { const point = this.draft.controlPoint; this.select((this.points || []).some(row => row.id === point.id) ? point.id : 'new'); this.draftId = point.id; this.label = point.label; this.due = this.$moment(point.due_at).format('YYYY-MM-DDTHH:mm'); } },
 methods: {
  refreshVersion() { const current = (this.points || []).find(p => p.id === this.selected); if (current) { this.original = {...current}; this.error = ''; } else this.error = 'Дата удалена. Выберите новую дату; введённые значения сохранены.'; },
  select(value) { this.selected=value; const point=(this.points || []).find(p=>p.id===value); this.original=point ? {...point} : null; this.label=point ? point.label : ''; this.due=point ? this.$moment(point.due_at).format('YYYY-MM-DDTHH:mm') : ''; this.error=''; },
  save(separate) {
   this.error='';
   if (this.changed && (!this.due || !this.$moment(this.due).isValid() || this.deadline && this.$moment(this.due).isAfter(this.deadline))) { this.error='Укажите дату контроля не позднее срока задачи.'; return; }
   const payload={control_point_id:this.selected || null};
   if (this.changed) {
    payload.controlPoint={id:separate || this.selected==='new' ? this.draftId : this.selected,label:this.label,due_at:this.$moment(this.due).toISOString(),revision:this.original && this.original.revision};
    payload.control_point_id=payload.controlPoint.id;
    if (this.shared && !separate) payload.confirmControlCount=this.original.linked_items_count;
   }
   this.$emit('save',payload);
  }
 }
};
</script>
